import { Injectable } from "@angular/core";
import { Observable, mergeMap } from "rxjs";
import { TeamAvatarModalData } from "@webapp/teams/models/add-team-avatar-form.models";
import { Team } from "../models/teams.models";
import { TeamsFacade } from "./teams-facade.service";

@Injectable()
export class UploadPictureService {
  constructor(private teamService: TeamsFacade) {}

  public handlePictureUpload$(data: TeamAvatarModalData): Observable<Team> {
    const { imgData, team, isUploadMediaAvatarEnabled } = data;

    return new Observable((observer) => {
      if (!imgData.pictureFile) {
        team.picture = "";
        observer.next(team);
        return observer.complete();
      }

      const uploadService = isUploadMediaAvatarEnabled ? this.teamService.uploadPictureV2$(imgData.pictureFile) : this.teamService.uploadPicture$(imgData.pictureFile);

      uploadService.subscribe({
        next: (imgUrl) => {
          team.picture = imgUrl.url;
          observer.next(team);
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        },
      });
    });
  }

  public uploadPicture$(data: TeamAvatarModalData): Observable<Team> {
    return this.handlePictureUpload$(data).pipe(
      mergeMap((team) => {
        const { id, avatar, color, picture } = team;
        return this.teamService.updateTeam$({
          id,
          avatar,
          color,
          picture,
        });
      })
    );
  }
}
